import privateHttpClient from '../privateHttpClient';
import { urlHttpGov } from '../../urls';
import AppUserAutoMapper from '../mappers/AppUserAutoMapper';
import { ICountAppUserAutoStats } from '../../../interfaces';

class AppUsersAutoService {
    private baseURL: string = `${urlHttpGov}/panel/app-user-auto`;

    async listAppUsersAuto(cityId: number, signal: AbortSignal) {

        const { data } = await privateHttpClient.get(`${this.baseURL}/county/${cityId}`, { signal });

        return data.map((user: any) => AppUserAutoMapper.toDomain(user));
    }
    async getAppUserAutoById(id: number, signal: AbortSignal) {
        const { data } = await privateHttpClient.get(`${this.baseURL}/${id}`, { signal });

        return AppUserAutoMapper.toDomain(data);
    }

    async getCountAppUserAutoByCityId(cityId: number, signal: AbortSignal): Promise<ICountAppUserAutoStats> {

        const { data } = await privateHttpClient.get(`${this.baseURL}/county/${cityId}/stats`, { signal });

        return data;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AppUsersAutoService();
